import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import makeStyles from "@mui/styles/makeStyles";
import { useTranslation } from "react-i18next";
import Typography from "@mui/material/Typography";

const useStyles = makeStyles(() => ({
  typeset: {
    "& ul, & ol": {
      paddingLeft: "2em",
    },
  },
}));

interface ICookieConsentDialogProps {
  isOpen: boolean;
  onAcceptAll: () => void;
  onRejectAll: () => void;
  onCloseDialog: () => void;
}

/**
 * This component is responsible for rendering a modal dialog which provides
 * the user with the information they need to accept or reject tracking cookies,
 * along with buttons to do so.
 *
 * It does not directly interact with the storage of this choice, and simply
 * calls one of the following props when the buttons are clicked:
 *
 * - onAcceptAll
 * - onRejectAll
 * - onCloseDialog
 */
export const CookieConsentDialog = (props: ICookieConsentDialogProps) => {
  const { isOpen, onAcceptAll, onRejectAll, onCloseDialog } = props;
  const { t } = useTranslation();
  const { t: st } = useTranslation("snippets");
  const classes = useStyles();
  const CookieSnippet = st("Cookies");

  return (
    <Dialog
      open={!!isOpen}
      onClose={onCloseDialog}
      className="marapp-qa-CookieConsentDialog"
      maxWidth="sm"
      fullWidth={true}
    >
      <DialogTitle>
        <Typography variant="h5" noWrap={true}>
          {t("Cookies")}
        </Typography>
      </DialogTitle>

      <DialogContent>
        <div className={classes.typeset}>
          <CookieSnippet />
        </div>
      </DialogContent>

      <DialogActions>
        <Button onClick={onCloseDialog} variant="text">
          {t("Cancel")}
        </Button>
        <Button onClick={onRejectAll} variant="outlined">
          {t("Reject")}
        </Button>
        <Button onClick={onAcceptAll} variant="contained" autoFocus={true}>
          {t("Accept")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
